import { CommonDefaultFilterKeys } from '@ardoq/api-types';

// TODO(typeName-migration): Delete this after BE migrates affectsTypeName→affectsTypeNames.
// All callers should then use affectsTypeNames directly (compiler errors will guide cleanup).
export const legacyAffectsTypeNames = (
  affectsTypeName?: string,
  affectsTypeNames?: string[]
): string[] | null =>
  affectsTypeNames?.length
    ? affectsTypeNames
    : affectsTypeName
      ? [affectsTypeName]
      : null;

type EntityTypeFilterArgs = {
  filterAttributeName: string;
  typeNameFilter: string[];
  entityTypeName: string | null | undefined;
};

export const isEntityTypeIncluded = ({
  filterAttributeName,
  typeNameFilter,
  entityTypeName,
}: EntityTypeFilterArgs): boolean => {
  if (filterAttributeName === CommonDefaultFilterKeys.TYPE) {
    return true;
  }

  return Boolean(entityTypeName && typeNameFilter.includes(entityTypeName));
};
